import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'dashed';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

/** Кнопка 26px/радиус 6 (DS v2.2): primary — графит (нейтральное главное), accent — cobalt (акцентное), secondary — тихая заливка, ghost — текстовое, dashed — «+ Фильтр». */
export function Button({ variant = 'secondary', className, type, ...rest }: ButtonProps) {
  const classes = ['btn', `btn--${variant}`, className].filter(Boolean).join(' ');
  return <button type={type ?? 'button'} className={classes} {...rest} />;
}
